import { IModel } from '@/@types/models/model';
import coreFields from './helpers/coreFields';

const PPZahtjev: IModel = {
  title: 'PP Zahtjev',
  apiPath: 'prostorni-planovi/zahtjevi',
  layer: 'PP_zahtjevi',
  forms: {
    default: {
      fields: [
        "external_id",
        "plan_name",
        "podnositelj",
        "podnositelj_adresa",
        "podnositelj_napomena",
        "podnositelj_ppt_mjesto",
        "podnositelj_ppt_broj",
        "zahtjev_status_id"
      ]
    }
  },
  listViews: {
    default: {
      fields: [
        "id",
        "plan_name",
        "external_id",
        "zahtjev_doc",
        "podnositelj",
        "podnositelj_adresa",
        "podnositelj_ppt_mjesto",
        "podnositelj_ppt_broj",
        "podnositelj_napomena",
        'urednost_status',
        "zahtjev_status_id",
        "kategorije",
        // "active",
        "docs"
      ],
      hidden: ["id"]
    }
  },
  fields: [
    coreFields.id,
    coreFields.active,
    {
      title: "External ID",
      source: "external_id",
      ttoken: "pp:zahtjevi.external_id",
      type: "wholenum",
      filter: true,
      readonly: true
    },
    {
      title: "Prostorni plan",
      source: "prostorni_plan_id",
      ttoken: "pp:prostorni_plan_id",
      type: 'picker',
      subModel: {
        apiPath: "prostorni-planovi?view=picker",
        format: "{label}",
        idattr: "id"
      },
      filter: true,
      readonly: true
    },
    {
      title: "Naziv plana",
      source: "plan_name",
      ttoken: "pp:zahtjevi.prostorni_plan",
      type: 'picker',
      subModel: {
        apiPath: "prostorni-planovi/zahtjevi/planovi?view=picker",
        format: "{label}",
        idattr: "id"
      },
      filter: true,
      readonly: true
    },
    {
      title: "Podnositelj",
      source: "podnositelj",
      ttoken: "pp:podnositelj",
      type: "text",
      filter: true,
      readonly: true
    },
    {
      title: "Podnositelj Adresa",
      source: "podnositelj_adresa",
      ttoken: "pp:podnositelj_adresa",
      type: "text",
      filter: true,
      readonly: true
    },
    {
      title: "Podnositelj Telefon",
      source: "podnositelj_tel",
      ttoken: "pp:podnositelj_tel",
      type: "text",
      filter: true,
      readonly: true
    },
    {
      title: "Podnositelj poštanski broj",
      source: "podnositelj_ppt_broj",
      ttoken: "pp:zahtjevi.podnositelj_ppt_broj",
      type: "text",
      filter: true,
      readonly: true
    },
    {
      title: "Podnositelj mjesto",
      source: "podnositelj_ppt_mjesto",
      ttoken: "pp:zahtjevi.podnositelj_ppt_mjesto",
      type: "text",
      filter: true,
      readonly: true
    },
    {
      title: "Podnositelj Napomena",
      source: "podnositelj_napomena",
      ttoken: "pp:podnositelj_napomena",
      type: "text",
      filter: true,
      readonly: true
    },
     {
      title: "Klasa",
      source: "klasa",
      ttoken: "pp:klasa",
      type: "text",
      filter: true,
      readonly: true
    },
    {
      title: "Status zahtjeva",
      source: "zahtjev_status_id",
      ttoken: "pp:zahtjev_status_id",
      type: 'picker',
      items: {
        labels: ['pp:zahtjev_statusi.razmatranje', 'pp:zahtjev_statusi.prihvacen', 'pp:zahtjev_statusi.odbijen', 'pp:zahtjev_statusi.dijelomicno'],
        values: [10, 20, 30, 40],
      },
      translate: true,
      filter: true,
      width: 'full'
    },
    {
      title: "Status urednosti zahtjeva",
      source: "urednost_status",
      ttoken: "pp:zahtjevi.urednost",
      type: 'picker',
      items: {
        icons: ['warning', 'check', 'thumb_up'],
        iconColors: ['#ffa600', '#00a702', '#0073E6'],
        labels: ['pp:zahtjevi.urednosti.not_ok','pp:zahtjevi.urednosti.ok', 'pp:zahtjevi.urednosti.checked'],
        values: [0, 1, 2],
      },
      translate: true,
      filter: true,
      readonly: true,
    },
    {
      title: 'Prilozi',
      source: 'docs',
      ttoken: 'common.attachments',
      type: 'document',
      subModel: {
        apiPath: 'core/documents',
        format: '{name}'
      },
      maxFiles: 10,
      filter: true,
    },
    {
      title: 'Zahtjev PDF',
      source: 'zahtjev_doc',
      ttoken: 'pp:zahtjevi.zahtjev_pdf',
      type: 'document',
      readonly: true,
      subModel: {
        apiPath: 'prostorni-planovi/zahtjevi/document',
        format: '{name}'
      },
      maxFiles: 1,
      filter: true,

    },
    {
      title: 'Kategorije',
      source: 'kategorije',
      ttoken: 'pp:zahtjevi.kategorije',
      type: 'text',
      filter: true,
      readonly: true,
    },
    coreFields.geom,
    coreFields.gid,
    coreFields.created_on
  ]

}

export default PPZahtjev;
